import { render, staticRenderFns } from "./ClientInvoices.vue?vue&type=template&id=248b9d3a&scoped=true&"
import script from "./ClientInvoices.vue?vue&type=script&lang=js&"
export * from "./ClientInvoices.vue?vue&type=script&lang=js&"
import style0 from "./ClientInvoices.vue?vue&type=style&index=0&id=248b9d3a&lang=scss&scoped=true&"
import style1 from "./ClientInvoices.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248b9d3a",
  null
  
)

export default component.exports